import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

const CheckFilled = (props: IconSvgProps) => {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM10.9047 16.8095C10.6035 16.8095 10.3663 16.6932 10.1339 16.3871L8.84295 14.8185L7.55203 13.2499C7.41449 13.0823 7.34182 12.8846 7.34182 12.6869C7.34182 12.2867 7.64215 11.9679 8.04303 11.9679C8.29201 11.9679 8.48963 12.0494 8.69682 12.3342L10.866 15.0555L15.2552 8.06776C15.4141 7.80037 15.6417 7.66277 15.8742 7.66277C16.2616 7.66277 16.6102 7.92447 16.6102 8.33427C16.6102 8.52415 16.5066 8.73054 16.3943 8.89909L11.6321 16.3871C11.4432 16.6719 11.1972 16.8095 10.9047 16.8095Z'
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
      />
    </BaseLibraryIconSvg>
  );
};

export default CheckFilled;
